export const ANIMATION_TIME = 600;
export const TIME_FOR_CLOSING_KEYBOARD = 500;
